import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import M0001AdminUser from '@/components/functions/Admin/M0001User/M0001AdminUserStore'
import M0301ScanRecord from '@/components/functions/Admin/M0301ScanRecord/M0301ScanRecordStore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.use(Vuex)
Vue.component('VCalendar', Calendar)
Vue.component('VDatePicker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    M0001AdminUser,
    M0301ScanRecord
  }
})
